import Cart from '@/app/_components/ui/icons/Cart.svg';
import ArrowLeft from '@/app/_components/ui/icons/ArrowLeft.svg';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import Image from 'next/image';
import PriceUnit from '../share/PriceUnit';
import { useRouter } from 'next/navigation';
import useCart from '@/app/_hooks/useCart';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function CartMenu({ session }) {
  const isMobile = useIsMobile();
  const [show, setShow] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const { cart } = useCart();
  const router = useRouter();

  const showDropdown = (e) => {
    setShow(true);
  };

  const hideDropdown = (e) => {
    setShow(false);
  };

  const openCartInMobile = () => {
    if (isMobile) {
      router.push('/checkout/cart');
    }
  };

  useEffect(() => {
    let quantity = 0;
    let amount = 0;
    if (cart && cart.items) {
      cart.items.forEach((item) => {
        if (item.variation) {
          quantity += item.number;
          amount += item.variation.sale * item.number;
        }
      });

      setTotalQuantity(quantity);
      setTotalAmount(amount);
    }
  }, [cart]);
  return (
    <>
      <div className="head-cart md:pr-3 cursor-pointer relative">
        <div
          className="flex items-center relative "
          onMouseEnter={showDropdown}
          onMouseLeave={hideDropdown}
          onClick={openCartInMobile}
        >
          <span className="absolute -left-3.5 -top-3.5 bg-color-primary items-center  text-xs text-white w-5 h-5 rounded-full flex justify-center">
            {totalQuantity}
          </span>

          <Cart stroke="#2A75BB" />
        </div>

        <div
          className={`dropDown absolute w-80 top-9 hidden shadow-md bg-white p-3 rounded-md left-0 z-20 ${
            show ? 'md:block' : ''
          }`}
          onMouseEnter={showDropdown}
          onMouseLeave={hideDropdown}
        >
          <div className="flex justify-between text-gray-400 text-sm">
            <div className="flex justify-center items-center gap-2">
              <span className=""> {totalQuantity}</span>
              <span>عدد</span>
            </div>

            <Link
              href="/checkout/cart"
              className="text-sm text-ocean-blue font-bold flex items-center"
            >
              <span className="pl-2">مشاهده سبد خرید</span>
              <ArrowLeft fill="#2A75BB" />
            </Link>
          </div>

          <div
            className={`mt-5  p-1 ${
              totalQuantity > 0
                ? `overflow-y-auto custom-scroll-bar h-36`
                : `h-10`
            }`}
          >
            {cart && cart.items ? (
              cart?.items.map((item, index) => (
                <div
                  className="flex justify-between items-start p-2 "
                  key={index}
                >
                  <div className="ml-2 border border-light-gray-300 rounded-md w-[75px] h-[75px]">
                    <Image
                      src={item.variation.product.media.thumb.full_path}
                      width={75}
                      height={75}
                      alt={item.variation.product.media.thumb.alt}
                      className="rounded-md"
                    />
                  </div>
                  <div className="flex-1 p-1">
                    <div className="text-sm font-medium">
                      {item.variation.product.title}
                    </div>
                    <div className="flex justify-between items-center text-gray-700 font-medium">
                      <div className="flex text-xs  pt-2">
                        {item.number}
                        <span>عدد</span>
                      </div>
                      <div className="flex items-center">
                        <PriceUnit price={item.variation.sale} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
          <div className="mt-6 border-b border-light-gray-300"></div>
          <div className="flex flex-col justify-between gap-3 items-center mt-2 w-full">
            <div className="flex justify-between items-center font-medium w-full">
              <span className="text-sm text-gray-400">جمع کل</span>
              <div className="flex items-center">
                <PriceUnit price={totalAmount} />
              </div>
            </div>
            <div className="w-full">
              <Link href="/checkout/cart" className="w-full">
                <button className="text-white text-sm w-full bg-color-primary py-2 rounded-md">
                  سبد خرید
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
